const ACTIVE = 'active';
const INACTIVE = 'inactive';

export const PAYMENT_METHOD_STATUS = {
  [ACTIVE]: ACTIVE,
  [INACTIVE]: INACTIVE
};

export const PAYMENT_METHOD_TYPES = {
  houseAccount: 'house-account',
  creditCard: 'credit-card'
};
